import axios from "axios";
import {
  scence,
  imgEdit,
  getImgItemList,
  delImgList,
  delImgVerificationList,
  getListUnusedFiles,
  deletePlotResource,
} from "@/api/api";
const MapModal = () => import("@/components/common/mapModal/Index");
const MapVideoPlay = () => import("@/components/common/mapVideoPlay/Index.vue");
const mapSwiper = () => import("@/components/common/swiper/Index.vue");

export default {
  name: "bimImageResources",
  props: ["sceneId", "getSchemeTree", "close", "selectedScene"],
  components: { MapModal, MapVideoPlay, mapSwiper },
  data() {
    return {
      checkedCities: [],
      collapseList: [],
      isResourcesClean: false,
      showimg: false,
      showVideo: false,
      articleString: null,
      imgList: [],
      videoList: [],
      uploadFilesList: [],
      bimImageResources: {
        title: "文件上传",
        id: "bimImageResources", // id和ref使用的同一个
      },
      modalNode: {
        bimImageResources: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 7,
            y: -70,
            // left: 22,
            // top:20
            unit: "%", // 默认px
          },
          width: "40%", // 宽度配置 默认450px
          height: "700px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
    };
  },
  computed: {
    // 默认展开所有
    activeId() {
      return this.collapseList.map((i) => {
        return i.id;
      });
    },
  },
  created() {
    this.imgData();
  },
  methods: {
    // 全选相关
    handleCheckAllChange(val) {
      if (val.checkAll) {
        const ids = val.children.map((item) => item);
        val.checkedCities = ids;
        val.isIndeterminate = false;
      } else {
        val.checkedCities = [];
      }
    },
    // 单选相关
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.collapseList.forEach((item) => {
        if (item.id === value[0]?.parentId) {
          item.checkAll = checkedCount === item.children.length;
          item.isIndeterminate =
            checkedCount > 0 && checkedCount < item.children.length;
        } else {
          item.checkAll = false;
          item.isIndeterminate = false;
        }
      });
    },
    // 删除选中
    deleteSelectCurrent() {
      let arr = [];
      this.collapseList.forEach((item) => {
        if (item.checkedCities.length > 0) {
          item.checkedCities.forEach((etem) => {
            arr.push({
              id: etem.id,
              filePath: etem.kvUnusedSceneFilesInfo.fileInfo,
            });
          });
        }
      });
      if (arr.length === 0) return;
      deletePlotResource(arr).then((res) => {
        if (res.data.code === 204 || res.data.code === 200) {
          this.$notify({
            title: "删除成功",
            message: "",
            type: "success",
            duration: 1000,
            offset: 320,
          });
          this.getList();
        }
      });
    },
    // 一键清空
    clearAll() {
      let arr = [];
      this.collapseList.forEach((item) => {
        if (item.children.length > 0) {
          item.children.forEach((etem) => {
            arr.push({
              id: etem.id,
              filePath: etem.kvUnusedSceneFilesInfo.fileInfo,
            });
          });
        }
      });
      if (arr.length === 0) return;
      deletePlotResource(arr).then((res) => {
        if (res.data.code === 204 || res.data.code === 200) {
          this.$notify({
            title: "删除成功",
            message: "",
            type: "success",
            duration: 1000,
            offset: 320,
          });
          this.getList();
        }
      });
    },
    // 返回
    back() {
      this.isResourcesClean = false;
      this.imgData();
    },
    // 获取数据
    getList() {
      // 获取公共的
      getListUnusedFiles({
        projectId: sessionStorage.getItem("nowProjectId"),
      }).then((res) => {
        let fileSuffix = ["jpg", "png", "jpeg", "gif", "svg"];
        let fileSuffix2 = ["mp4"];
        res.data.data.forEach((element) => {
          element.checkedCities = []; //勾选数组
          element.isIndeterminate = false; // 默认否
          element.checkAll = false; // 默认否
          element.children.forEach((item) => {
            const lastDotIndex = item.text.lastIndexOf(".");
            let extension;
            if (lastDotIndex !== -1) {
              extension = item.text.slice(lastDotIndex + 1);
              const image = fileSuffix.find((item) => item === extension);
              if (image) {
                item.resourcesType = "image";
                return;
              }
              const video = fileSuffix2.find((item) => item === extension);
              if (video) {
                item.resourcesType = "video";
              }
            }
          });
        });
        this.collapseList = res.data.data;
      });
    },
    // 资源清理
    resoucesClean() {
      this.isResourcesClean = true;
      this.getList();
    },
    // 查看图片资源
    view(data) {
      let fileSuffix = ["jpg", "png", "jpeg", "gif", "svg"];
      let fileSuffix2 = ["mp4"];
      if (!data.filePath) {
        data.filePath = data.kvUnusedSceneFilesInfo.fileInfo;
        data.remarks = data.kvUnusedSceneFilesInfo.remarks;
      }
      const lastDotIndex = data.filePath.lastIndexOf(".");
      let extension;
      if (lastDotIndex !== -1) {
        extension = data.filePath.slice(lastDotIndex + 1);
      }
      if (extension) {
        // 适应之前的数据状态
        const image = fileSuffix.find((item) => item === extension);
        if (image) {
          this.imgList = [
            {
              src: data.filePath,
              text: data.remarks,
            },
          ];
          this.showimg = true;
          return;
        }
        const video = fileSuffix2.find((item) => item === extension);
        if (video) {
          this.videoList = [
            {
              src: data.filePath,
            },
          ];
          this.showVideo = true;
          return;
        }
      }
    },
    // 获取资源数据
    imgData() {
      // 请求附件列表
      const params = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        dataType:
          this.selectedScene && this.selectedScene.id == this.sceneId ? 2 : 1,
        pId: this.sceneId, //场景id 分组id
      };
      getImgItemList(params).then((res2) => {
        res2.data.data.forEach((item) => {
          item.disabled = true;
        });
        this.uploadFilesList = res2.data.data;
      });
    },
    // 点击上传
    httpRequest(item) {
      // if (item.file.size / 1024 / 1024 / 10 > 4) {
      //   this.$message({
      //     type: "error",
      //     message: "文件过大，请上传小于40MB的文件！",
      //   });
      //   return false;
      // }
      this.modalNode.bimImageResources.loading = true;
      item.file.remarks = "";
      let formData = new FormData();
      formData.append("files", item.file);
      formData.append("businessType", "BimPlanScenesFile");
      formData.append(
        "projectId",
        window.sessionStorage.getItem("nowProjectId")
      );
      formData.append("businessId", 123456789);
      axios
        .post("/baseIP/sysFileInfo/uploadmultiple", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        })
        .then((res) => {
          this.modalNode.bimImageResources.loading = false;
          let Arr = {
            projectId: window.sessionStorage.getItem("nowProjectId"),
            pId: this.sceneId,
            name: item.file.name,
            fileId: res.data.data[0],
            dataType:
              this.selectedScene && this.selectedScene.id == this.sceneId
                ? 2
                : 1,
          };
          scence([Arr]).then(
            (res2) => {
              if (res2.data.code == 200 || res2.data.code == 204) {
                this.imgData();
                if (this.getSchemeTree) {
                  this.getSchemeTree();
                }
                this.$notify({
                  title: "上传成功",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                this.$notify({
                  title: "上传失败",
                  message: "",
                  type: "error",
                  duration: 960,
                  offset: 320,
                });
              }
            },
            (err) => {
              this.$notify({
                title: "上传失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          );
        });
    },
    // 保存按钮
    submit: _.debounce(function (e, data) {
      let objData = {
        id: data.id,
        projectId: data.projectId,
        pId: data.pId,
        name: data.name,
        remarks: e ? e.target.value : data.remarks,
        dataType:
          this.selectedScene && this.selectedScene.id == this.sceneId ? 2 : 1,
      };
      imgEdit(objData).then((res) => {
        if (this.getSchemeTree) {
          this.getSchemeTree();
        }
        this.$notify({
          title: "保存成功",
          message: "",
          type: "success",
          duration: 960,
          offset: 320,
        });
        this.imgData();
      });
    }, 500),
    // 编辑名字
    edit(e) {
      e.row.disabled = false;
      this.$nextTick(function () {
        this.$refs[`remarks${e.$index}`].focus();
      });
    },
    // 更新
    updateHttpRequest(scope, item) {
      // if (item.file.size / 1024 / 1024 / 10 > 2) {
      //   this.$message({
      //     type: "error",
      //     message: "文件过大，请上传小于20MB的文件！",
      //   });
      //   return false;
      // }
      this.modalNode.bimImageResources.loading = true;
      item.file.remarks = "";
      let formData = new FormData();
      formData.append("files", item.file);
      scope.row.remarks = scope.row.remarks ? scope.row.remarks : "";
      scope.row.name = item.file.name;
      for (let key in scope.row) {
        formData.append(key, scope.row[key]);
      }
      axios
        .post("/baseIP/BimPlanScenesFile/editFile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        })
        .then((res) => {
          this.modalNode.bimImageResources.loading = false;
          this.$notify({
            title: "更新成功",
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
          this.imgData();
        });
    },
    // 删除图片
    delImg(data) {
      let objData = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        pId: data.pId,
        id: data.id,
      };
      delImgVerificationList(objData)
        .then((res) => {
          let { code, data } = res.data;
          if (code == 200 || code == 204) {
            if (data.length > 0) {
              this.$message({
                showClose: true,
                message: `此次更新会影响到 ${data.toString()} 标绘!!!`,
                duration: 0,
                type: "error",
              });
            } else {
              // this.modalNode.planDemo.loading = false;
              delImgList(objData).then((res) => {
                if (this.getSchemeTree) {
                  this.getSchemeTree();
                }
                this.$notify({
                  title: "删除成功",
                  message: "",
                  type: "success",
                  duration: 1000,
                  offset: 320,
                });
                this.imgData();
              });
            }
          } else {
            // this.modalNode.planDemo.loading = false;
            this.$notify({
              title: "网络不佳",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        })
        .catch((error) => {
          // console.log(error);
          // this.modalNode.planDemo.loading = false;
          this.$notify({
            title: "网络不佳",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    // 关闭弹窗
    closeImg() {
      this.close("imageResources");
    },
  },
};
